var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeuillecocotier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 160,
    viewBox: "0 0 131 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.923 53.4912C111.91 84.4111 154.133 114.677 154.807 115.269C153.713 106.191 127.347 66.1144 114.3 47.2111L113.923 53.4912Z",
    fill: "#57CA7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6445 106.564C94.1305 99.2425 135.621 108.997 154.68 114.789C156.447 114.659 156.394 114.845 142.043 116.63C127.692 118.416 87.1855 115.281 68.7263 113.49C67.0798 114.232 67.1585 113.885 80.6445 106.564Z",
    fill: "#57CA7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7509 53.8266C93.7162 65.9871 153.181 113.518 154.968 113.94L156.221 116.694C150.221 116.886 110.706 100.569 82.7021 85.4158C60.2988 73.2935 34.7624 50.6309 24.7946 40.8149C26.4582 41.0987 36.1786 44.0982 61.7509 53.8266Z",
    fill: "#0E8D48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.458 85.0893C90.6839 70.5317 90.9813 44.5772 93.2267 33.4197C94.6603 64.1369 133.077 100.152 152.107 114.319C144.213 110.642 124.231 99.6469 107.458 85.0893Z",
    fill: "#57CA7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.498 59.7913C147.313 69.5194 152.748 94.925 154.238 106.412L156.115 115.821C153.307 111.424 146.657 100.41 142.526 91.5278C138.395 82.6452 137.453 66.6691 137.498 59.7913Z",
    fill: "#0E8D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.318 58.0342L155.711 114.771C151.206 114.133 140.087 110.461 131.649 100.879C123.212 91.2963 123.913 68.323 125.318 58.0342Z",
    fill: "#53CC7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.202 106.743C122.677 100.372 145.114 109.671 154.897 115.117C150.653 123.875 111.541 122.1 92.5156 120.117C93.9632 118.313 99.7272 113.113 111.202 106.743Z",
    fill: "#53CC7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.367 124.815C127.252 119.097 147.667 116.493 156.263 115.906C154.737 117.259 148.556 121.447 136.036 127.376C123.516 133.306 102.092 135.056 92.9453 135.189C94.7168 134.114 101.481 130.534 114.367 124.815Z",
    fill: "#0E8D48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.688 133.649C134.022 121.097 149.291 116.619 155.634 115.949C155.429 116.305 154.458 117.423 152.218 119.053C149.417 121.091 144.46 122.29 137.527 131.486C131.98 138.842 119.777 146.755 114.368 149.792C115.396 146.324 121.01 137.585 123.688 133.649Z",
    fill: "#3CAB61"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M118.167 70.7622C124.386 80.038 152.467 112.292 154.599 113.522C152.786 113.965 146.246 113.289 134.582 107.042C120.003 99.2344 112.276 80.9656 105.12 71.5547C99.3954 64.0259 93.9163 43.8331 91.8923 34.6778C90.2569 31.297 87.8824 25.0934 91.467 27.3254C95.9477 30.1155 111.949 61.4864 118.167 70.7622Z",
    fill: "#0E8D48"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7393 34.037C74.9846 36.8129 126.518 86.5459 151.754 111.065L154.617 114.546C153.164 114.249 146.944 111.659 133.683 103.678C117.107 93.7019 83.9927 65.243 74.5225 56.3235C66.9464 49.1879 54.0491 26.8375 48.5475 16.5543C54.8275 16.9313 65.4327 30.5671 70.7393 34.037Z",
    fill: "#0C8E46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2681 95.698C92.0501 86.669 136.213 105.276 155.571 115.708C141.761 111.728 110.754 103.722 97.2141 103.539C83.6743 103.357 57.0771 107.643 45.4709 109.809C44.6608 108.867 48.4861 104.727 70.2681 95.698Z",
    fill: "#54CA7C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1763 75.4105C79.7527 77.579 131.155 102.897 153.783 115.285C136.612 116.539 61.0651 90.1814 44.1012 84.0423C30.5301 79.1309 19.8661 74.788 16.2305 73.2305C18.9722 73.0536 30.5999 73.2421 55.1763 75.4105Z",
    fill: "#0C8E46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9978 71.4565C112.3 78.5396 142.875 103.705 155.75 115.403C142.967 115.738 123.251 105.574 99.9211 93.9315C81.2569 84.6177 62.8127 67.7014 55.9236 60.4074C60.2391 61.1392 73.6955 64.3734 92.9978 71.4565Z",
    fill: "#57CA7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeuillecocotier);
export default __webpack_public_path__ + "static/media/feuillecocotier.11798ea35abe5a7b130a324dd1d104a4.svg";
export { ForwardRef as ReactComponent };